module.exports = __webpack_public_path__ + "img/finish_user.bceecae8.png";